import Vue from 'vue'
import ElementUI from "element-ui"
import VueI18n from 'vue-i18n'
import VueCookie from 'vue-cookie'
// elment-ui 
import locale from "element-ui/lib/locale"
import zhLocale from "element-ui/lib/locale/lang/zh-CN"
import enLocale from "element-ui/lib/locale/lang/en"

// 自定义
import en from "../language/en.json"
import zh from "../language/zh.json" //繁中
// import ko from "../language/ko.json" //韓語
// import ja from "../language/ja.json" //日语

Vue.use(VueI18n) // 这里一行是必须加的。
// 在该js文件中，单独注册一个i18n实例并引入语言文件
const messages = {
  "zh": {
    ...zh,
    ...zhLocale
  },
  "en": {
    ...en,
    ...enLocale
  },
  // "ko": {
  //   ...ko,
  //   ...koLocale
  // },
  // "ja": {
  //   ...ja,
  //   ...jaLocale
  // }
}


const i18n = new VueI18n({
  messages,
  fallbackLocale: "zh", // 匹配不到时默认的语言
  locale: VueCookie.get('DakaLang') || 'zh',
})
locale.i18n((key, value) => i18n.t(key, value))

// 非 vue 文件中使用这个方法
const translate = (localeKey) => {
  const locale = VueCookie.get('DakaLang') || 'zh'
  const hasKey = i18n.te(localeKey, locale)  // 使用i18n的 te 方法来检查是否能够匹配到对应键值
  const translatedStr = i18n.t(localeKey)
  if (hasKey) {
    return translatedStr
  }
  return localeKey
}
export { i18n, messages, translate }
// export default { i18n };


// WEBPACK FOOTER //
// ./src/language/i18n_mounting.js